import { Typography } from "@mui/material";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const MacidSecurityDialog = (props) => {
  const { onSubmit, handleSecurityDialogOpen, isDisabled } = props;

  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const submit = () => {
    if (validator.current.allValid()) {
      onSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <>
      <Typography p="12px 24px">
        Are you sure you want to disable security? Once you perform this action,
        user can access Recipe App from any store without MAC ID.
      </Typography>

      <CustomDialogFooter
        onSubmit={submit}
        disabled={isDisabled}
        handleClose={() => handleSecurityDialogOpen(false)}
        submitButton="Disable"
        sx={{ px: "20px", pb: "20px" }}
      />
    </>
  );
};
